import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6" data-testid="not-found-page">
      <div className="max-w-md text-center">
        <p className="text-6xl font-black text-purple-600 mb-3">404</p>
        <h1 className="text-2xl font-bold text-gray-900">Page not found</h1>
        <p className="text-gray-500 text-sm mt-2 mb-6">
          The page you&apos;re looking for doesn&apos;t exist.
        </p>
        <Link
          to="/"
          data-testid="btn-go-home"
          className="inline-flex items-center gap-2 bg-purple-600 text-white px-5 py-2.5 rounded-lg font-semibold hover:bg-purple-700"
        >
          Go to homepage
        </Link>
      </div>
    </div>
  );
}
